// File: /src/contexts/ConfirmDialogContext.js

import React, { createContext, useState, useCallback, useMemo } from 'react';
import ConfirmDialog from '../components/common/ConfirmDialog';

export const ConfirmDialogContext = createContext();

export function ConfirmDialogProvider({ children }) {
	const [dialogState, setDialogState] = useState({
		open: false,
		title: '',
		message: '',
		onConfirm: null,
		confirmText: 'Confirmar',
		cancelText: 'Cancelar',
		variant: 'danger',
	});

	const showConfirm = useCallback(
		({
			title,
			message,
			onConfirm,
			confirmText = 'Confirmar',
			cancelText = 'Cancelar',
			variant = 'danger',
		}) => {
			return new Promise((resolve) => {
				setDialogState({
					open: true,
					title,
					message,
					confirmText,
					cancelText,
					variant,
					onConfirm: () => {
						resolve(true);
						setDialogState((prev) => ({ ...prev, open: false }));
						if (onConfirm) onConfirm();
					},
				});
			});
		},
		[]
	);

	const handleCancel = useCallback(() => {
		setDialogState((prev) => ({ ...prev, open: false }));
	}, []);

	const value = useMemo(() => ({ showConfirm }), [showConfirm]);

	return (
		<ConfirmDialogContext.Provider value={value}>
			{children}
			<ConfirmDialog
				open={dialogState.open}
				title={dialogState.title}
				message={dialogState.message}
				onConfirm={dialogState.onConfirm}
				onCancel={handleCancel}
				confirmText={dialogState.confirmText}
				cancelText={dialogState.cancelText}
				variant={dialogState.variant}
			/>
		</ConfirmDialogContext.Provider>
	);
}
